import history from "@history";
import { setDefaultSettings, setInitialSettings } from "app/store/actions/fuse";
import _ from "@lodash";
import store from "app/store";
import * as Actions from "app/store/actions";
import firebase from "firebase/app";
import firebaseService from "app/services/firebaseService";
import auth0Service from "app/services/auth0Service";
import jwtService from "app/services/jwtService";

export const SET_USER_DATA = "[USER] SET DATA";
export const REMOVE_USER_DATA = "[USER] REMOVE DATA";
export const USER_LOGGED_OUT = "[USER] LOGGED OUT";

/**
 * Set user data from Auth0 token data
 */
export function setUserDataAuth0(tokenData) {
	const user = {
		role: ["admin"],
		from: "auth0",
		data: {
			displayName: tokenData.username,
			photoURL: tokenData.picture,
			email: tokenData.email,
			settings:
				tokenData.user_metadata && tokenData.user_metadata.settings
					? tokenData.user_metadata.settings
					: {},
			shortcuts:
				tokenData.user_metadata && tokenData.user_metadata.shortcuts
					? tokenData.user_metadata.shortcuts
					: [],
		},
	};

	return setUserData(user);
}

/**
 * Set user data from Firebase data
 */
export function setUserDataFirebase(user, authUser) {
	if (
		user &&
		user.settings &&
		user.settings.theme &&
		user.settings.layout &&
		user.settings.layout.style
	) {
		// Set user data but do not update
		return setUserData(user);
	} else {
		// Create missing user settings
		return createUserSettingsFirebase(authUser);
	}
}

/**
 * Create User Settings with Firebase data
 */
export function createUserSettingsFirebase(authUser) {
	return (dispatch, getState) => {
		const guestUser = getState().auth.user;
		const fuseDefaultSettings = getState().fuse.settings.defaults;
		const currentUser = firebase.auth().currentUser;

		/**
		 * Merge with current Settings
		 */
		const user = _.merge({}, guestUser, {
			uid: authUser.uid,
			from: "firebase",
			role: ["wait"],
			displayName: authUser.displayName,
			photoURL: "assets/images/avatars/profile.jpg",
			email: authUser.email,
			shortcuts: [],
			settings: { ...fuseDefaultSettings },
			timestamp: firebase.firestore.FieldValue.serverTimestamp(),
		});
		currentUser.updateProfile(user);

		updateUserData(user);
		return dispatch(setUserData(user));
	};
}

/**
 * Set User Data
 */
export function setUserData(user) {
	return (dispatch) => {
		dispatch(setDefaultSettings(user.settings));

		dispatch({
			type: SET_USER_DATA,
			payload: user,
		});
	};
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
	return async (dispatch, getState) => {
		const oldUser = getState().auth.user;
		const user = _.merge({}, oldUser, { settings });

		await updateUserData(user);

		return dispatch(setUserData(user));
	};
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
	return async (dispatch, getState) => {
		const user = getState().auth.user;
		const newUser = {
			...user,
			shortcuts,
		};

		await updateUserData(newUser);

		return dispatch(setUserData(newUser));
	};
}

/**
 * Remove User Data
 */
export function removeUserData() {
	return {
		type: REMOVE_USER_DATA,
	};
}

/**
 * Logout
 */
export function logoutUser() {
	return (dispatch, getState) => {
		const user = getState().auth.user;

		if (!user.role || user.role.length === 0) {
			// is guest
			return null;
		}

		history.push({
			pathname: "/login",
		});

		switch (user.from) {
			case "firebase": {
				firebaseService.signOut();
				break;
			}
			case "auth0": {
				auth0Service.logout();
				break;
			}
			default: {
				jwtService.logout();
			}
		}

		dispatch(setInitialSettings());

		dispatch({
			type: USER_LOGGED_OUT,
		});
	};
}

/**
 * Update User Data
 */
async function updateUserData(user) {
	if (!user.role || user.role.length === 0) {
		// is guest
		return;
	}

	switch (user.from) {
		case "firebase": {
			firebaseService
				.createAdminData(user)
				.then(() => {
					store.dispatch(
						Actions.showMessage({ message: "회원 정보 저장 완료" })
					);
				})
				.catch((error) => {
					store.dispatch(Actions.showMessage({ message: error.message }));
				});
			break;
		}
		case "auth0": {
			auth0Service
				.updateUserData({
					settings: user.settings,
					shortcuts: user.shortcuts,
				})
				.then(() => {
					store.dispatch(
						Actions.showMessage({ message: "User data saved to auth0" })
					);
				})
				.catch((error) => {
					store.dispatch(Actions.showMessage({ message: error.message }));
				});
			break;
		}
		default: {
			await jwtService
				.updateUserData(user)
				.then(() => {
					store.dispatch(
						Actions.showMessage({ message: "사용자 데이터 업데이트 완료" })
					);
				})
				.catch((error) => {
					store.dispatch(Actions.showMessage({ message: error.message }));
				});
			break;
		}
	}
}
